import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { serviceCostModel, serviceModel } from '~/models';
import { inputBillingDataToModel } from '~/models/service-billing/setters';
import { inputCostDataToModel } from '~/models/service-cost';
const getServicesWithNewData = (param)=>{
    let { serviceData, serviceId, services } = param;
    return services.map((s)=>s.id === serviceId ? serviceModel.fromFields(_object_spread({}, s, serviceData)) : s);
};
const getServicesBundlesWithNewData = (param)=>{
    let { serviceId, serviceBundles, serviceData } = param;
    return serviceBundles ? {
        bundles: serviceBundles.bundles.map((bundle)=>bundle.services.find((s)=>s.id === serviceId) ? _object_spread_props(_object_spread({}, bundle), {
                services: getServicesWithNewData({
                    serviceData,
                    serviceId,
                    services: bundle.services
                })
            }) : bundle)
    } : undefined;
};
export const getDraftServicesWithNewData = (param)=>{
    let { serviceData, serviceId, draft } = param;
    const bundles = draft.serviceBundles();
    return {
        serviceBundles: getServicesBundlesWithNewData({
            serviceData,
            serviceId,
            serviceBundles: bundles.length > 0 ? {
                bundles
            } : undefined
        }),
        services: getServicesWithNewData({
            serviceData,
            serviceId,
            services: draft.services()
        })
    };
};
export const getServiceName = (param)=>{
    let { draft, serviceId } = param;
    var _bundle_services_find, _draft_services_find;
    const bundle = draft.serviceBundles().find((b)=>b.services.find((s)=>s.id === serviceId));
    if (bundle) return ((_bundle_services_find = bundle.services.find((s)=>s.id === serviceId)) === null || _bundle_services_find === void 0 ? void 0 : _bundle_services_find.name) || '';
    return ((_draft_services_find = draft.services().find((s)=>s.id === serviceId)) === null || _draft_services_find === void 0 ? void 0 : _draft_services_find.name) || '';
};
export const billingFormToService = (param)=>{
    let { service, billingForm } = param;
    const { pricing, price, minPrice, unitCap, unitName } = billingForm;
    const priceIncrease = serviceModel.priceIncrease(service);
    const cost = inputCostDataToModel({
        pricing,
        price: +price,
        minPrice,
        discount: service.cost.discount,
        priceIncrease,
        unitCap,
        unitName
    });
    const billing = inputBillingDataToModel({
        billingForm,
        originalService: service
    });
    return _object_spread_props(_object_spread({}, service), {
        cost,
        billing
    });
};
export const getPriceData = (cost)=>{
    const discount = serviceCostModel.discount(cost);
    return {
        price: serviceCostModel.isRangePrice(cost) ? {
            minPrice: serviceModel.minPrice({
                cost
            }),
            maxPrice: serviceModel.price({
                cost
            })
        } : serviceModel.price({
            cost
        }),
        hasDiscount: discount != null && discount.amount().gt(0),
        discountedPrice: serviceCostModel.isRangePrice(cost) ? {
            minPrice: serviceModel.minPriceFinal({
                cost
            }),
            maxPrice: serviceModel.applyDiscount({
                cost
            })
        } : serviceModel.finalPrice({
            cost
        }, 1)
    };
};
